import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteCity = ({ cityId }: { cityId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/Cities/DeleteCity/${cityId}`);
};

type QueryFnType = typeof deleteCity;

type UseDeleteCityOptions = {
  cityId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteCity = ({ config }: UseDeleteCityOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllCities"]);
      addNotification(`Η Πόλη Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteCity,
  });
};
